/** Keys that activate a focused control, like a click (as native buttons do). */
const ACTIVATION_KEYS: readonly string[] = ["Enter", " "];

export function isActivationKey(key: string): boolean {
  return ACTIVATION_KEYS.includes(key);
}

/** Elements inside a row that handle their own clicks, so the row must not react to them. */
const OWN_CLICK_TARGETS = "button, a, input, select, label";

export function isInsideOwnClickTarget(target: EventTarget): boolean {
  return target instanceof Element && target.closest(OWN_CLICK_TARGETS) !== null;
}
